export const checkout = {
  url: "https://senior-activity-hub.impultienda.ar/checkout",
  price: "29",
  currency: "USD",
};

export const productName = "The Activity Director’s Year-Round Kit";

export const tagline = "Open it, look, and lead.";

export const guarantee = {
  days: 10,
  title: "10-day money-back guarantee",
  text: "Try the kit for 10 days. If it isn’t right for you, we’ll refund your money — no hassle, no questions asked.",
};

export const images = {
  boxMockup: "https://cdn.magicpatterns.com/uploads/hT2sp5tepMFJLTSQY9Zz9r/Kit_premium_de_actividades_para_adultos_mayores.png",
  bookCover: "https://cdn.magicpatterns.com/uploads/sjkn7sJP3r8ykDrRcAojZe/01_portada.png",
  bingoPage: "https://cdn.magicpatterns.com/uploads/7Sc3k8ocSKSwyBHd22WuCJ/02_bingo_objetos.png",
};

export const book = {
  label: "Volume 01 · Part 01",
  title: "Group Games & Social Fun",
  activityCount: 10,
  description:
    "Your first 10 ready-to-lead activities: themed bingo, choice activities, cooperative games and seated group sessions with clear rules.",
  features: ["Coordinator run sheets", "Large-print materials", "Practical adaptations"],
  sampleActivities: [
    { code: "G001", name: "Everyday Object Bingo" },
    { code: "G002", name: "This or That? Conversation Circle" },
    { code: "G008", name: "Let’s Plan a Shared Garden" },
    { code: "G009", name: "Find the Connection" },
  ],
};

export const heroChecks = ["1 Book", "5 Bonuses", "10 Activities", "12-Month Calendar", "Large Print"];

export const trustStats = [
  { value: "10", label: "Ready-to-lead activities" },
  { value: "1 + 5", label: "Book & bonuses" },
  { value: "12", label: "Month calendar" },
  { value: "Worldwide", label: "Senior activity resources" },
];

export const problems = [
  {
    icon: "clock",
    title: "Planning after your shift",
    description: "You finish today’s program, then spend the evening searching for tomorrow’s.",
  },
  {
    icon: "bookmark",
    title: "Ideas without instructions",
    description: "A saved pin gives you the idea, not the rules, questions or materials to run it.",
  },
  {
    icon: "users",
    title: "One room, different abilities",
    description: "Some residents want a challenge. Others need a seated or simpler way to join in.",
  },
  {
    icon: "refresh",
    title: "Plans change at short notice",
    description: "A smaller group or a cancelled outing, and you need something ready in minutes.",
  },
] as const;

export const audiences = [
  { role: "Activity Directors", benefit: "lead prepared sessions without starting from scratch." },
  { role: "New coordinators", benefit: "use clear steps and opening scripts." },
  { role: "Small teams", benefit: "keep preparation and materials together." },
  { role: "Adult day programs", benefit: "select sessions to fit your group." },
];

export const workflowSteps = [
  { title: "Open the calendar", description: "Choose when to run each session across the year." },
  { title: "Print the materials", description: "Follow the printing list for boards, cards or sheets." },
  { title: "Follow the instructions", description: "Use the opening script, numbered steps and adaptations." },
];

export const samplePages = [
  { label: "Volume 01 · Cover", src: images.bookCover },
  { label: "G001 · Everyday Object Bingo", src: images.bingoPage },
  { label: "G002 · This or That? cards", src: "https://cdn.magicpatterns.com/uploads/4QpsiDyVz8b4bfcemeSZDN/03_this_or_that.png" },
  { label: "G008 · Shared Garden layout", src: "https://cdn.magicpatterns.com/uploads/wvCNv47S8RBmevEjJbNm3T/04_garden_plan.png" },
  { label: "G009 · Find the Connection cards", src: "https://cdn.magicpatterns.com/uploads/uvg262winidh6h11vHabHe/05_find_the_connection.png" },
];

export const bonuses = [
  {
    title: "The Last-Minute Activity Rescue Kit",
    benefit:
      "20 short activities using basic supplies, with clear instructions and seated options for changes of plan or smaller groups.",
    src: "https://cdn.magicpatterns.com/uploads/uH6wM8J8amxdGb3DejTPE7/mockup-the-last-minute-activity-rescue-kit.png",
  },
  {
    title: "The Resident Interests & Preferences Kit",
    benefit: "Conversation guides and preference sheets to explore favorite topics, hobbies and ways to participate.",
    src: "https://cdn.magicpatterns.com/uploads/e7KYTxLruYHJ6N6pdQ4uF9/mockup-the-resident-interests-preferences-kit.png",
  },
  {
    title: "The Monthly Materials Planner",
    benefit: "Checklists linked to the activity calendar, reusable supply tracking and low-cost material alternatives.",
    src: "https://cdn.magicpatterns.com/uploads/kTBV6jPHRQtxfGB8eXTFmF/mockup-the-monthly-materials-planner.png",
  },
  {
    title: "The Printable Activity Invitation Pack",
    benefit:
      "Large-print posters, invitation cards and reminders with space to add your activity, date, time and location.",
    src: "https://cdn.magicpatterns.com/uploads/kHG92FLtyQ7jouU1JLVVF6/mockup-the-printable-activity-invitation-pack.png",
  },
  {
    title: "The Team Handover & Volunteer Quick-Start Kit",
    benefit:
      "Briefing cards and handover sheets explaining the planned session, materials, preparation and when to ask staff for support.",
    src: "https://cdn.magicpatterns.com/uploads/8MefcRWeC98Qbqb9HkARGm/mockup-the-team-handover-volunteer-quick-start-kit.png",
  },
];

export const offerIncluded = [
  "Volume 01: Group Games & Social Fun",
  "10 ready-to-lead activities",
  "12-month activity calendar",
  "Large-print materials",
  "Coordinator run sheets",
];

export const comparison = {
  without: [
    "Searching for tomorrow’s idea after your shift",
    "Writing rules and questions from scratch",
    "Improvising when the plan changes",
    "Re-explaining the session at every handover",
  ],
  with: [
    "Your sessions planned in a 12-month calendar",
    "Run sheet, materials and opening script ready to print",
    "20 rescue activities for last-minute changes",
    "Handover cards for the next team member",
  ],
};

export const faqs = [
  {
    question: "What exactly do I receive?",
    answer:
      "Volume 01 — Group Games & Social Fun (Part 01) with 10 ready-to-lead activities, a 12-month activity calendar, large-print participant materials, coordinator run sheets and the five bonus resources listed above, all as downloadable PDFs.",
  },
  {
    question: "Do I need experience to lead these activities?",
    answer:
      "No. Each session includes a materials list, an opening script, numbered steps and practical adaptations, so new coordinators can follow along.",
  },
  {
    question: "What format is the kit in?",
    answer: "It is a digital PDF product in English. No physical books are shipped.",
  },
  {
    question: "How do I receive the kit?",
    answer: "The kit is delivered as a PDF download. Delivery and access details are shown at checkout.",
  },
  {
    question: "Do I need to print the entire pack?",
    answer:
      "No. Keep the PDFs on your device and print only the participant materials for your chosen session. Each page tells you how many copies to print.",
  },
  {
    question: "Will I need extra materials?",
    answer:
      "Some sessions use everyday supplies such as markers or scissors. Each activity lists what to gather before you start.",
  },
  {
    question: "Can I adapt activities for different participants?",
    answer:
      "Yes. The kit includes participation options and adaptations. Choose according to each person’s interests, communication, vision, hearing, movement and support needs.",
  },
  {
    question: "Does this replace all of our daily programming?",
    answer:
      "No. Use the activities and the calendar alongside your existing daily program, residents’ preferences and your setting’s care guidance.",
  },
  {
    question: "Is this a dementia treatment program?",
    answer:
      "No. This is a recreational activity resource. It does not provide medical treatment, clinical assessment or dementia therapy.",
  },
  {
    question: "Is there a guarantee?",
    answer:
      "Yes. You have a 10-day money-back guarantee. If the kit isn’t right for you, we’ll refund your money — no hassle, no questions asked.",
  },
  {
    question: "How do I pay? Is there a subscription?",
    answer: `It is a one-time payment of $${checkout.price} ${checkout.currency}. There is no subscription or recurring fee. Available payment methods are shown at checkout.`,
  },
];
